import Can from "components/Can/Can";
import { DACA_PERMISSIONS } from "constants/index";
import { Formik } from "formik";
import React, { Component } from "react";
import Button from "../../components/Button/button.component";
import DropdownFilter from "../../components/DropdownFilter/dropdownFilter.component";
import Table from "../../components/Table/table.component";
import Title from "../../components/Title/title.component";
import dacaService from "../../services/dacaService";
import estoqueService from "../../services/estoqueService";
import ToastHelper from "../../utils/toastHelper";
import DevolucaoModal from "./devolucao.modal";
import EditarModal from "./editarItemDaca.modal";
import EntradaModal from "./entrada.modal";
import ListarHistoricoDaca from "./listarHistorico/listarHistoricoDaca";
import MovimentacaoModal from "./movimentacao.modal";
import EmprestimoDescarteModal from "./saida.emprestimoDescarte.modal";
import SaidaModal from "./saida.modal";

export default class GerenciarItemDaca extends Component {
	state = {
		daca: {
			estoques: []
		},
		dacaId: 0,
		entrada: {
			nome: ""
		},
		isOpenRegistrar: false,
		isOpenSaida: false,
		isOpenMovimentacao: false,
		isOpenEditar: false,
		isOpenEmprestimo: false,
		isOpenDevolucao: false,
		isOpenEmprestimoDescarte: false,
		eventos: [],
		historicoDaca: [],
		tipoExibicaoEstoqueDACA: []
	};

	filtrosHistorico = [
		{ id: 0, nome: "Entrada" },
		{ id: 1, nome: "Saída" },
		{ id: 2, nome: "Movimentação de estoque" }
	];

	columns = [
		{ id: 0, title: "Tipo de estoque", property: "nomeTipoEstoque" },
		{
			id: 1,
			title: "Valor unitário (R$)",
			property: "valorUnitarioFormatado",
			number: true
		},
		{
			id: 2,
			title: "Quantidade disponível",
			property: "quantidadeDisponivel",
			number: true
		},
		{
			id: 3,
			title: "Quantidade reservada",
			property: "quantidadeReservada",
			number: true
		}
	];

	columnsHistoricoEmprestimo = [
		{ id: 0, title: "Local", property: "destinoEmprestimo" },
		{ id: 1, title: "Evento", property: "isEventoDescricao" },
		{ id: 2, title: "Data", property: "dataCadastro" },
		{
			id: 3,
			title: "Quantidade",
			property: "quantidadeEmprestada",
			number: true
		}
	];

	componentDidMount() {
		this.initialize();
	}

	handleVoltar = () => {
		const { history } = this.props;
		history.push("/listadaca");
	};

	header = daca => (
		<div>
			<div className="row">
				<div className="col-md-12">
					<div className="row">
						<div className="col-md-4 pb-3">
							<b>Código:</b> {daca.id}
						</div>
						<div className="col-md-5 pb-3">
							<b>Item:</b> {daca.nome}
						</div>
						<div className="col-md-3 d-flex align-items-start justify-content-end">
							<Can
								perform={DACA_PERMISSIONS.GERENCIAR_ITEM}
								yes={() => (
									<Button
										primary
										type="button"
										text="Editar item"
										onClick={this.handleOpenModalEditar}
										icon="fas fa-edit"
									/>
								)}
								no={() => <span />}
							/>
						</div>
						<div className="col-md-4">
							<b>Tipo do item:</b>{" "}
							{daca.permanente
								? "Material permanente"
								: "Bens de consumo"}
						</div>
						<div className="col-md-8 pb-3">
							<b>Quantidade em estoque:</b>{" "}
							{daca.quantidadeTotalEmEstoque}
						</div>
						<div className="col-md-4 pb-3">
							<b>Local de exibição:</b>{" "}
							{daca.tiposExibicaoFormatado}
						</div>
						<div className="col-md-8 pb-3 text-justify">
							<b>Descrição:</b> {daca.descricao}
						</div>
					</div>
				</div>
			</div>
		</div>
	);

	/*
		MODAL MOVIMENTAÇÃO ESTOQUE
	*/
	handleOpenModalMovimentacao = () => {
		this.setState({ isOpenMovimentacao: true });
	};

	handleCloseMovimentacao = () => {
		this.setState({ isOpenMovimentacao: false });
	};

	handleSalvarMovimentacao = async (values, { resetForm }) => {
		await estoqueService.createMovimentacao(values);
		ToastHelper.success("Movimentação cadastrada com sucesso.");
		this.initialize();
		resetForm();
	};

	createModalMovimentacao = item =>
		this.state.isOpenMovimentacao && (
			<MovimentacaoModal
				isOpenMovimentacao={this.state.isOpenMovimentacao}
				handleCloseMovimentacao={this.handleCloseMovimentacao}
				handleSalvarMovimentacao={this.handleSalvarMovimentacao}
				dacaId={item.id}
				nomeDaca={this.state.nomeDaca}
			/>
		);

	handleChangeCheckboxGroupEstoque(value) {
		const filter = value.map(f => f.id);
		this.setState({ tipoExibicaoEstoqueDACA: filter });
		this.updateList(this.state.historicoDaca, filter);
	}

	daca(daca) {
		const initialValues = {
			transacao: [
				{ id: "ENTRADA", nome: "Entrada" },
				{ id: "SAIDA", nome: "Saída" },
				{ id: "MOVIMENTACAO", nome: "Movimentação" },
				{ id: "DEVOLUCAO", nome: "Devolução" },
				{ id: "DESCARTE", nome: "Descarte" }
			]
		};

		const {
			paginaEstoqueAtualConteudo,
			itemsPorPagina,
			paginaEstoqueAtual,
			estoquePaginas,
			totalElementsEstoque,
			paginaHistoricoEmprestimoAtualConteudo,
			historicoEmprestimoPaginas,
			paginaHistoricoEmprestimoAtual,
			totalElementsHistoricoEmprestimo
		} = this.state;

		return (
			<div>
				<Formik
					initialValues={initialValues}
					enableReinitialize
					onSubmit={this.handleSubmit}
					render={({ setFieldValue, values, errors }) => {
						this.setFieldValue = setFieldValue;
						return (
							<div>
								<div className="row mt-2">
									<div className="col-md-12">
										<div className="card">
											<div className="card-header">
												Estoque
											</div>
											<div className="row container d-flex align-items-center mt-3">
												<div className="col-md-6">
													<Can
														perform={
															DACA_PERMISSIONS.GERENCIAR_ENTRADA
														}
														yes={() => (
															<Button
																type="button"
																size="sm"
																primary
																icon="fas fa-plus"
																text="Entrada"
																onClick={
																	this
																		.handleOpenRegistrar
																}
															/>
														)}
														no={() => <span />}
													/>

													<Can
														perform={[
															DACA_PERMISSIONS.GERENCIAR_SAIDA,
															DACA_PERMISSIONS.GERENCIAR_SAIDA_REGIONAL
														]}
														yes={() => (
															<Button
																type="button"
																size="sm"
																primary
																icon="fas fa-minus"
																text="Saída"
																onClick={() =>
																	this.state
																		.daca
																		.permanente ===
																	true
																		? this.handleOpenEmprestimoDescarte()
																		: this.handleOpenSaida()
																}
															/>
														)}
														no={() => <span />}
													/>

													<Can
														perform={[
															DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO,
															DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO_REGIONAL
														]}
														yes={() => (
															<Button
																type="button"
																size="sm"
																primary
																icon="fas fa-exchange-alt"
																text="Movimentação de estoque"
																onClick={
																	this
																		.handleOpenModalMovimentacao
																}
															/>
														)}
														no={() => <span />}
													/>
												</div>
												<div className="col-md-6">
													<div className="col-md-12">
														<div className="row mt-1">
															<div className="col-md-12 pr-0">
																<DropdownFilter
																	aroundAlign
																	handleChangeCheckboxGroup={value =>
																		this.handleChangeCheckboxGroupEstoque(
																			value
																		)
																	}
																	filtro={
																		values.tipoExibicaoEstoqueDACA ||
																		[]
																	}
																	checkboxValuesList={[
																		{
																			id:
																				"COM_ESTOQUE",
																			nome:
																				"Com estoque"
																		},
																		{
																			id:
																				"SEM_ESTOQUE",
																			nome:
																				"Sem estoque"
																		}
																	]}
																	error={
																		errors.tipoExibicaoEstoqueDACA
																	}
																	setFieldValue={
																		setFieldValue
																	}
																	name="tipoExibicaoEstoqueDACA"
																	id="tipoExibicaoEstoqueDACA"
																	keyName="tipoExibicaoEstoqueDACA"
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="row container mt-3 mb-3">
												<Table
													align="left"
													rtl
													columns={this.columns}
													data={
														paginaEstoqueAtualConteudo ||
														[]
													}
													onChangePage={n =>
														this.setState({
															paginaEstoqueAtual: n,
															paginaEstoqueAtualConteudo: daca.estoques.slice(
																n *
																	itemsPorPagina,
																(n + 1) *
																	itemsPorPagina
															)
														})
													}
													currentPage={
														paginaEstoqueAtual
													}
													emptyMessage="Não há estoques cadastrados. "
													emptyColSpan={
														this.columns.length
													}
													totalPages={
														estoquePaginas - 1
													}
													showPaginate={
														!daca.estoques
															? false
															: daca.estoques
																	.length > 0
													}
													totalElements={
														totalElementsEstoque
													}
													totalItemPages={
														typeof paginaEstoqueAtualConteudo ===
														"undefined"
															? 0
															: paginaEstoqueAtualConteudo.length
													}
												/>
											</div>
										</div>
									</div>
								</div>

								{daca.permanente === true && (
									<div className="row mt-2">
										<div className="col-md-12">
											<div className="card">
												<div className="card-header">
													Empréstimo
												</div>
												<div className="row container mt-3">
													<div className="col">
														<Can
															perform={[
																DACA_PERMISSIONS.GERENCIAR_DEVOLUCAO,
																DACA_PERMISSIONS.GERENCIAR_DEVOLUCAO_REGIONAL
															]}
															yes={() => (
																<Button
																	type="button"
																	size="sm"
																	primary
																	icon="fas fa-reply"
																	text="Devolução"
																	onClick={
																		this
																			.handleOpenDevolucao
																	}
																/>
															)}
															no={() => <span />}
														/>
													</div>
												</div>
												<div className="row container mt-3 mb-3">
													<Table
														align="left"
														columns={
															this
																.columnsHistoricoEmprestimo
														}
														data={
															paginaHistoricoEmprestimoAtualConteudo ||
															[]
														}
														onChangePage={n =>
															this.setState({
																paginaHistoricoEmprestimoAtual: n,
																paginaHistoricoEmprestimoAtualConteudo: daca.historicosEmprestimo.slice(
																	n *
																		itemsPorPagina,
																	(n + 1) *
																		itemsPorPagina
																)
															})
														}
														totalPages={
															historicoEmprestimoPaginas -
															1
														}
														currentPage={
															paginaHistoricoEmprestimoAtual
														}
														emptyMessage="Não há itens emprestados."
														emptyColSpan={
															this
																.columnsHistoricoEmprestimo
																.length
														}
														showPaginate={
															!daca.historicosEmprestimo
																? false
																: daca
																		.historicosEmprestimo
																		.length >
																  0
														}
														totalElements={
															totalElementsHistoricoEmprestimo
														}
														totalItemPages={
															typeof paginaHistoricoEmprestimoAtualConteudo ===
															"undefined"
																? 0
																: paginaHistoricoEmprestimoAtualConteudo.length
														}
														/* Booleano para mostrar ou não o total da coluna quantidade */
														showTotal={
															daca
																.historicosEmprestimo
																.length > 0
														}
														nomeVariavelSoma="quantidadeEmprestada"
													/>
												</div>
											</div>
										</div>
									</div>
								)}

								<div className="row mt-2">
									<div className="col-md-12">
										<div className="card">
											<div className="card-header">
												Histórico
											</div>
											{daca.id && (
												<ListarHistoricoDaca
													daca={daca}
													ref={ref => {
														this.historicoDacaComponentRef = ref;
													}}
													handleSubmit={() =>
														this.initialize()
													}
												/>
											)}
										</div>
									</div>
								</div>
							</div>
						);
					}}
				/>
			</div>
		);
	}

	footer() {
		return (
			<div className="col-6">
				<div className="row">
					<div className="col-md-12">
						<div className="float-left ">
							<Button
								primary
								type="button"
								text="Voltar"
								onClick={this.handleVoltar}
								icon="fas fa-arrow-left"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	/*
		MODAL REGISTRAR
	*/

	handleOpenRegistrar = () => {
		this.setState({ isOpenRegistrar: true });
	};

	handleCloseRegistrar = () => {
		this.setState({ isOpenRegistrar: false });
	};

	handleSubmitEntrada = async (values, { resetForm }) => {
		await estoqueService.createEstoque(values);
		ToastHelper.success("Entrada cadastrada com sucesso.");
		this.initialize();
		resetForm();
	};

	createModalEntrada = item =>
		this.state.isOpenRegistrar && (
			<EntradaModal
				isOpenRegistrar={this.state.isOpenRegistrar}
				handleCloseRegistrar={this.handleCloseRegistrar}
				handleSubmitEntrada={this.handleSubmitEntrada}
				dacaId={item.id}
				nomeDaca={this.state.nomeDaca}
			/>
		);

	/*
		MODAL SAÍDA
	*/

	handleOpenSaida = () => {
		this.setState({ isOpenSaida: true });
	};

	handleCloseSaida = () => {
		this.setState({ isOpenSaida: false });
	};

	handleSubmitSaida = async (values, { resetForm }) => {
		if (values.isEvento === "true") {
			values.documento = undefined;
			values.motivo = "";
		} else {
			values.ocorrencia.id = 0;
		}

		await estoqueService.saveSaida(values);
		ToastHelper.success("Saída cadastrada com sucesso!");
		this.initialize();
		resetForm();
	};

	createModalSaida = item =>
		this.state.isOpenSaida && (
			<SaidaModal
				isOpenSaida={this.state.isOpenSaida}
				handleCloseSaida={this.handleCloseSaida}
				handleSubmitSaida={this.handleSubmitSaida}
				dacaId={item.id}
				nomeDaca={this.state.nomeDaca}
			/>
		);

	/*
		MODAL CADASTRAR EMPRESTIMO OU DESCARTE
	*/

	handleOpenEmprestimoDescarte = () => {
		this.setState({ isOpenEmprestimoDescarte: true });
	};

	handleCloseEmprestimoDescarte = () => {
		this.setState({ isOpenEmprestimoDescarte: false });
	};

	handleSubmitEmprestimoDescarte = async (values, { resetForm }) => {
		if (values.emprestimo === "true") {
			if (values.isEvento === "true") {
				values.documento = undefined;
				values.motivo = "";
				values.destinoEmprestimo = undefined;
			} else {
				values.ocorrencia.id = 0;
			}
		} else {
			values.destinoEmprestimo = undefined;
			values.ocorrencia.id = 0;
			values.documento = undefined;
			values.isEvento = undefined;
		}

		await estoqueService.saveSaida(values);
		ToastHelper.success("Saída cadastrada com sucesso.");
		this.initialize();
		resetForm();
	};

	createModalEmprestimoDescarte = item =>
		this.state.isOpenEmprestimoDescarte && (
			<EmprestimoDescarteModal
				isOpenEmprestimoDescarte={this.state.isOpenEmprestimoDescarte}
				handleCloseEmprestimoDescarte={
					this.handleCloseEmprestimoDescarte
				}
				handleSubmitEmprestimoDescarte={
					this.handleSubmitEmprestimoDescarte
				}
				dacaId={item.id}
				nomeDaca={this.state.nomeDaca}
			/>
		);

	/*
		MODAL EDITAR ESTOQUE
	*/
	handleOpenModalEditar = () => {
		this.setState({ isOpenEditar: true });
	};

	handleCloseEditar = () => {
		this.setState({ isOpenEditar: false });
	};

	handleSubmitEditar = async values => {
		await dacaService.editarItemDaca(values);
		ToastHelper.success("Edição concluída com sucesso.");
		this.initialize();
		this.handleCloseEditar();
	};

	createModalEditar = (item, { isOpenEditar }) =>
		isOpenEditar && (
			<EditarModal
				isOpenEditar={isOpenEditar}
				handleCloseEditar={this.handleCloseEditar}
				handleSubmitEditar={this.handleSubmitEditar}
				daca={item}
			/>
		);

	exportar = () => (
		<div className="col-12 mb-3">
			<div className="row">
				<div className="col-md-12">
					<div className="float-right ">
						<Button
							primary
							type="button"
							text="Exportar"
							icon="fas fa-file-excel"
						/>
					</div>
				</div>
			</div>
		</div>
	);

	/*
		MODAL DEVOLUÇÃO
	*/
	handleOpenDevolucao = () => {
		this.setState({ isOpenDevolucao: true });
	};

	handleCloseDevolucao = () => {
		this.setState({ isOpenDevolucao: false });
	};

	handleSubmitDevolucao = async values => {
		await dacaService.devolucaoItemDaca(values);
		ToastHelper.success("Devolução concluída com sucesso.");
		this.initialize();
		this.setState({ isOpenDevolucao: false });
	};

	createModalDevolucao = (item, { isOpenDevolucao }) =>
		isOpenDevolucao && (
			<DevolucaoModal
				isOpenDevolucao={isOpenDevolucao}
				handleCloseDevolucao={this.handleCloseDevolucao}
				handleSalvarDevolucao={this.handleSubmitDevolucao}
				daca={item}
				nomeDaca={this.state.nomeDaca}
			/>
		);

	async updateList(historicoDaca, tipoExibicaoEstoqueDACA) {
		const { dacaId } = this.state;
		const { data } = await dacaService.findByIdAndHistorico(
			dacaId,
			historicoDaca,
			tipoExibicaoEstoqueDACA
		);

		const itemsPorPagina = 15;

		const paginaEstoqueAtual = 0;
		const paginaHistoricoEmprestimoAtual = 0;

		const estoquePaginas =
			Math.ceil(data.estoques.length / itemsPorPagina) + 1;
		const historicoEmprestimoPaginas =
			Math.ceil(data.historicosEmprestimo.length / itemsPorPagina) + 1;

		this.setState({
			daca: data,
			nomeDaca: data.nome,
			itemsPorPagina,

			totalElementsHistorico: data.historicos.length,
			totalElementsEstoque: data.estoques.length,
			totalElementsHistoricoEmprestimo: data.historicosEmprestimo.length,
			estoquePaginas,
			paginaEstoqueAtual,
			paginaEstoqueAtualConteudo: data.estoques.slice(
				paginaEstoqueAtual,
				paginaEstoqueAtual + itemsPorPagina
			),

			historicoEmprestimoPaginas,
			paginaHistoricoEmprestimoAtual,
			paginaHistoricoEmprestimoAtualConteudo: data.historicosEmprestimo.slice(
				paginaHistoricoEmprestimoAtual,
				paginaHistoricoEmprestimoAtual + itemsPorPagina
			)
		});
	}

	initialize() {
		const {
			match: { params }
		} = this.props;

		this.setState({
			historicoDaca: [
				"ENTRADA",
				"SAIDA",
				"MOVIMENTACAO",
				"DEVOLUCAO",
				"DESCARTE",
				"RESERVA_PDR",
				"SAIDA_PDR"
			]
		});
		this.setState({ tipoExibicaoEstoqueDACA: ["COM_ESTOQUE"] });
		/*
			Desestruturação está quebrando o funcionamento nessa linha, manter o acesso
			ao estado da forma que está.
		*/
		this.setState(
			{ dacaId: params.id },
			// eslint-disable-next-line react/destructuring-assignment
			() =>
				this.updateList(
					this.state.historicoDaca,
					this.state.tipoExibicaoEstoqueDACA
				)
		);
		this.setState({ isOpenRegistrar: false });
		this.setState({ isOpenMovimentacao: false });
		this.setState({ isOpenSaida: false });
		this.setState({ isOpenEditar: false });
		this.setState({ isOpenEmprestimo: false });
		this.setState({ isOpenEmprestimoDescarte: false });
		this.setFieldValue("tipoExibicaoEstoqueDACA", [
			{ id: "COM_ESTOQUE", nome: "Com estoque" }
		]);
		this.setFieldValue("historicoDaca", [
			{ id: "ENTRADA", nome: "Entrada" },
			{ id: "SAIDA", nome: "Saída" },
			{ id: "MOVIMENTACAO", nome: "Movimentação" },
			{ id: "RESERVA_PDR", nome: "Reserva-PDR" },
			{ id: "SAIDA_PDR", nome: "Saída-PDR" },
			{ id: "DEVOLUCAO", nome: "Devolução" },
			{ id: "DESCARTE", nome: "Descarte" }
		]);
		this.setState({ isOpenEmprestimo: false });
		/* Recarrega o histórico de transação através da referência do componente de listagem */
		if (this.historicoDacaComponentRef)
			this.historicoDacaComponentRef.initialize(true);
	}

	render() {
		const { daca } = this.state;

		return (
			<div>
				<div className="row">
					<div className="col-md-12">
						<Can
							perform={[
								DACA_PERMISSIONS.GERENCIAR_ITEM,
								DACA_PERMISSIONS.GERENCIAR_ENTRADA,
								DACA_PERMISSIONS.GERENCIAR_SAIDA,
								DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO,
								DACA_PERMISSIONS.GERENCIAR_DEVOLUCAO,

								DACA_PERMISSIONS.GERENCIAR_SAIDA_REGIONAL,
								DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO_REGIONAL,
								DACA_PERMISSIONS.GERENCIAR_DEVOLUCAO
							]}
							yes={() => <Title>Gerenciar item</Title>}
							no={() => <Title>Visualizar item</Title>}
						/>
					</div>
				</div>

				<div className="card container">
					<div className="card-body">
						{this.header(daca)}
						{this.daca(daca)}
						<div className="row mt-2">{this.footer()}</div>
						{this.createModalSaida(daca)}
						{this.createModalEntrada(daca)}
						{this.createModalMovimentacao(daca)}
						{this.createModalEditar(daca, this.state)}
						{this.createModalDevolucao(daca, this.state)}
						{this.createModalEmprestimoDescarte(daca)}
					</div>
				</div>
			</div>
		);
	}
}
